<template>
  <div class="container is-fluid mb-6">
    <div class="is-flex py-2">
      <!-- <p class="is-size-5 ml-4 has-text-info-dark is-pulled-left">
                <i class="fas fa-boxes mr-2"></i> 
                User Roles  
            </p> -->
    </div>
    <div class="columns pt-4">
      <div class="column is-6">
        <div class="mb-2 is-flex">
          <span>
            <a :href="$route.params.module == 'users' ? '/user-permissions/roles' : $route.params.module == 'roles' ? '/user-permissions/users' : ''" class="mr-2 mt-">
              <i class="fa fa-chevron-left"></i>
            </a>
          </span>

          <span class="mb-0 ml-1 is-uppercase font-light">{{ $route.params.module == "users" ? "Perdorues" : $route.params.module == "roles" ? "Role dhe te drejta" : "" }}</span>
          <span v-if="$route.params.module == 'users'" class="ml-auto">
            <a v-if="am_allowed('user_roles.can_create_user')" @click.prevent="start_create_new_user()" href="" class="is-underlined ml-auto">
              <i class="fas mr-1" :class="[show_create_new_user ? 'fa-times' : 'fa-plus']"></i>
            </a>
          </span>
          <span v-if="$route.params.module == 'roles'" class="ml-auto">
            <a v-if="am_allowed('user_roles.can_create_role')" @click.prevent="start_create_new_role()" href="" class="is-underlined ml-auto">
              <i class="fas mr-1" :class="[show_create_new_role ? 'fa-times' : 'fa-plus']"></i>
            </a>
          </span>
        </div>
        <div v-if="$route.params.module == 'users'">
          <div class="mb-5">
            <div class="is-flex is-flex-wrap-wrap is-align-items-center gap-2 mb-3">
              <div class="field mb-0">
                <label class="label is-size-7 mb-0">Roli</label>
                <div class="control">
                  <select v-model="users_filter_type_id" class="input is-small" style="min-width: 10rem" @change="fetch_users">
                    <option value="">Te gjithe</option>
                    <option v-for="ut in user_types_list" :key="ut.id" :value="ut.id">{{ ut.name }}</option>
                  </select>
                </div>
              </div>
              <label class="checkbox is-size-7 mt-5">
                <input v-model="users_show_inactive" type="checkbox" @change="fetch_users" />
                Shfaq perdoruesit joaktiv
              </label>
            </div>
            <div v-if="show_create_new_user" class="has-border px-3 mb-3">
              <DaForm v-if="form_create_user_data" @submitted="create_user" :form="form_create_user_data" @close="form_create_user_data = null" :closes_form="true"></DaForm>
            </div>
            <simple-pagination :items="users_list" :entityType="'user'" :itemsPerPage="10" :show_more="true" @open_item="open_edit_user_form"></simple-pagination>
          </div>
        </div>
        <div v-if="$route.params.module == 'roles'">
          <div v-if="$route.params.module == 'roles'">
            <div v-if="show_create_new_role" class="has-border my-2">
              <DaForm v-if="show_create_new_role" @submitted="create_role" :form="form_create_role_data"></DaForm>
            </div>
            <table class="table is-striped is-bordered is-fullwidth is-narrow is-hoverable">
              <tbody>
                <tr v-for="(user_type, index) in user_types_list" :key="index" class="">
                  <td @click="change_selected_role(user_type)" class="has-text-centered is-vcentered" width="6%">
                    <input :checked="user_type.id == selected_role_data.id" type="radio" name="answer" />
                  </td>
                  <td>
                    <div v-if="!user_type.edit_mode">
                      <p class="is-flex">
                        <span class="is-flex-grow-1 is-clickable" @click="change_selected_role(user_type)">
                          {{ user_type.name }}
                        </span>
                        <a v-if="am_allowed('user_roles.can_edit_role')" @click.prevent="start_show_edit_role(user_type)" href="" class="is-pulled-right">
                          <small><i class="fas fa-pencil-alt"></i></small>
                        </a>
                        <a v-if="am_allowed('user_roles.can_create_role')" @click.prevent="start_copy_role(user_type)" href="" class="is-pulled-right mr-2" title="Kopjo rolin">
                          <small><i class="fas fa-copy"></i></small>
                        </a>
                      </p>
                    </div>
                    <div v-else class="field has-addons">
                      <p class="control is-expanded">
                        <input v-model="user_type.new_name" class="input is-success is-small" type="text" :placeholder="'role_name'" />
                      </p>
                      <p class="control">
                        <a @click.prevent="start_show_edit_role(user_type)" class="button is-small">
                          <i class="fas fa-times"></i>
                        </a>
                      </p>
                      <p class="control">
                        <a @click.prevent="save_user_type(user_type)" class="button is-small">
                          <i class="fa fa-check"></i>
                        </a>
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="$route.params.module == 'roles'" class="column is-6">
        <div v-if="selected_role_data.id">
          <p class="is-size-5 mb-2">{{ selected_role_data.name }}</p>
          <div class="tabs is-boxed is-size-7 mb-2">
            <ul>
              <li :class="{ 'is-active': rolePanelTab === 'permissions' }">
                <a @click.prevent="rolePanelTab = 'permissions'">Te drejtat</a>
              </li>
              <li :class="{ 'is-active': rolePanelTab === 'history' }">
                <a @click.prevent="rolePanelTab = 'history'">Historik</a>
              </li>
            </ul>
          </div>
          <div v-if="rolePanelTab === 'history'" class="role-form-history">
            <div class="mb-2 has-text-weight-semibold">Logu audit i roleve</div>
            <SubjectAudit kind="role" :subject-id="selected_role_data.id" :reload-key="roleHistoryReloadKey" empty-text="Nuk ka veprime të audituara për këtë rol."></SubjectAudit>
          </div>
          <div v-else>
            <div class="role-editor-toolbar mb-2">
              <input v-model="permissionSearch" class="input is-small" type="text" placeholder="Kerko te drejta..." />
              <label class="checkbox is-size-7 ml-2">
                <input v-model="showChangedOnly" type="checkbox" />
                Vetem te ndryshuarat
              </label>
              <div v-if="am_allowed('user_roles.can_edit_permissions')" class="is-flex is-align-items-center ml-auto">
                <select v-model="copyFromTypeId" class="input is-small" style="min-width: 10rem">
                  <option value="">Kopjo nga nje rol...</option>
                  <option v-for="ut in copyFromRoleOptions" :key="ut.id" :value="ut.id">{{ ut.name }}</option>
                </select>
                <a class="button is-small ml-1" :disabled="!copyFromTypeId" @click.prevent="applyCopyFromRole">Apliko</a>
              </div>
            </div>
            <div v-for="(key, index) in visibleRoleModules" :key="index" class="has-border mb-2">
              <p class="py-1 px-2 has-text-dark flex" style="background: aliceblue">
                <span @click.prevent="toggle_collapse_role(key)" class="cursor-pointer text-slate-400 mr-2">
                  <span v-if="key.is_collapsed">
                    <i class="fa-solid fa-chevron-down"></i>
                  </span>
                  <span v-else>
                    <i class="fa-solid fa-chevron-up"></i>
                  </span>
                </span>
                <span @click.prevent="toggle_collapse_role(key)" class="is-capitalized flex-grow cursor-pointer">
                  {{ key.module_title }}
                </span>
                <span v-if="am_allowed('user_roles.can_edit_permissions') && !key.is_collapsed" @click="check_all_group(key)" class="is-pulled-right has-text-grey is-size-7 is-clickable">
                  <span v-if="are_all_checked(key)"> <i class="far fa-square"></i> {{ "Caktivizo te gjitha" }} </span>
                  <span v-else>
                    <i class="far fa-check-square"></i>
                    {{ "Aktivizo te gjitha" }}
                  </span>
                </span>
              </p>
              <PermissionMatrix
                v-if="!key.is_collapsed && hasPermissionMatrix(key.module_name)"
                :module-key="key.module_name"
                :permissions="key.permissions"
                :can-edit="am_allowed('user_roles.can_edit_permissions')"
              />
              <div v-else-if="!key.is_collapsed" class="is-flex is-flex-wrap-wrap">
                <div v-for="(permission, indexa) in visibleModulePermissions(key)" :key="indexa" class="has-border is-flex is-flex-direction-column" style="width: 15%; border-bottom: solid 1px #dedede">
                  <span class="is-flex is-justify-content-center" style="">
                    <p class="mb-1 pt-1 pl-1" style="font-size: 12px; word-break: break-word">
                      <tippy arrow interactive :hide-on-click="false" @state="() => {}">
                        <span v-if="Number.isInteger(permission.value) && permission.value != permission.original_value" class="transparent-btn is-small pl-1" :content="permission.description">
                          <i class="fas fa-exclamation-triangle is-small has-text-danger mr-1"></i>
                        </span>
                      </tippy>
                      {{ permission.short_description }}
                    </p>
                  </span>
                  <div class="is-flex-grow-2 is-flex is-justify-content-center is-align-items-center">
                    <label class="checkbox py-1 px-6">
                      <input v-model="permission.value" :disabled="!am_allowed('user_roles.can_edit_permissions')" true-value="1" false-value="0" type="checkbox" />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <a v-if="have_changed && am_allowed('user_roles.can_edit_permissions') && !save_permissions_loading" @click.prevent="save_role_permissions()" class="button is-success is-small is-fullwidth mb-3" href="">{{
                "Ruaj ndryshimet"
              }}</a>
              <a v-if="save_permissions_loading" @click.prevent="() => {}" href="" disabled class="button is-success is-small is-fullwidth mb-3">
                <i class="fa fa-spinner fa-spin mr-2"></i>
                {{ "Ruaj ndryshimet" }}
              </a>
            </div>
          </div>
        </div>
        <div v-else class="column is-flex is-align-items-center is-justify-content-center">
          <span class="has-border p-3">
            {{ "Zgjidhni njerin nga rolet" }}
          </span>
        </div>
      </div>
      <div v-if="form_edit" class="column is- sticky-form">
        <div class="tabs is-boxed is-size-7 mb-0">
          <ul>
            <li :class="{ 'is-active': userFormTab === 'form' }">
              <a @click.prevent="userFormTab = 'form'">Perdoruesi</a>
            </li>
            <li :class="{ 'is-active': userFormTab === 'history' }">
              <a @click.prevent="userFormTab = 'history'">Historik</a>
            </li>
          </ul>
        </div>
        <DaForm v-show="userFormTab === 'form'" v-if="form_edit" @submitted="submitUser" :form="form_edit" @close="closeUserForm" :closes_form="true"> </DaForm>
        <div v-if="userFormTab === 'history'" class="px-2 pb-3">
          <div class="mb-2 has-text-weight-semibold">Logu audit i perdoruesve</div>
          <SubjectAudit kind="user" :subject-id="selected_user.id" :reload-key="userHistoryReloadKey" compact empty-text="Nuk ka veprime të audituara për këtë perdorues."></SubjectAudit>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import permissionMixin from "@/mixins/permissions-mixin.js";
import { hasPermissionMatrix, injectStandaloneAttributeModule, visiblePermissionNames } from "./permission-matrix-config.js";
import PermissionMatrix from "./PermissionMatrix.vue";
import SubjectAudit from "./SubjectAudit.vue";
import Api from "@/services/Api";
import RolePermissions from "@/services/RolePermissions";
import { Tippy } from "vue-tippy";
import "tippy.js/dist/tippy.css"; // tippy for styling
import DaForm from "@/components/daform/index.vue";
// import userPos from "./components/user_pos";
// import userWarehouse from "./components/user_warehouse";
// import userSteps from "./components/user_steps";
import editUser from "./forms/edit";
import simplePagination from "@/components/simple_pagination.vue";

// import { EventBus } from '@/event-bus'
// import { ModelListSelect } from 'vue-search-select'

export default {
  mixins: [permissionMixin],

  components: {
    Tippy,
    DaForm,
    PermissionMatrix,
    SubjectAudit,
    simplePagination,
    // userPos,
    // userWarehouse,
    // userSteps
    // ModelListSelect
  },

  data() {
    return {
      user_types_list: [],
      permissions_list: {},
      show_create_new_role: false,
      new_role: {},
      show_permissions_section: false,
      show_create_permission: false,
      new_permission: {},
      show_edit_role: false,
      selected_role_data: {},
      role_user_tab: "roles",
      users_list: [],
      show_create_new_user: false,
      new_user: {},
      form_create_user_data: null,

      options1: [
        { code: "01", name: "aa", desc: "desc01" },
        { code: "02", name: "ab", desc: "desc02" },
        { code: "03", name: "bc", desc: "desc03" },
        { code: "04", name: "cd", desc: "desc04" },
        { code: "05", name: "de", desc: "desc05" },
        { code: "06", name: "ef", desc: "desc06" },
      ],
      form_create_role_data: null,
      save_permissions_loading: false,
      form_edit: null,
      selected_user: {},
      users_filter_type_id: "",
      users_show_inactive: false,
      rolePanelTab: "permissions",
      userFormTab: "form",
      permissionSearch: "",
      showChangedOnly: false,
      copyFromTypeId: "",
      roleHistoryReloadKey: 0,
      userHistoryReloadKey: 0,
    };
  },
  async created() {
    if (!this.am_allowed("user_roles.can_see_user_roles")) {
      window.location.href = "/home";
      // this.$router.replace({path: '/home'})
    } else {
      await this.refreshPermissionCatalog();
      await Api(true)
        .post("/get/user/types")
        .then((res) => {
          this.user_types_list = res.data.map((ut) => {
            ut.edit_mode = false;
            ut.new_name = ut.name;
            return ut;
          });
          return res.data;
        });
      await this.fetch_users();
    }
    // Set app_route for hepls routes
    // EventBus.$emit('set_route', this.get_url())
    // EventBus.$emit('set_lang', this.$i18n.locale)
  },
  computed: {
    have_changed() {
      let change_found = false;
      this.user_role_permissions_modules.map((m) => {
        m.permissions.map((p) => {
          if (typeof p.value === "string") {
            p.value = parseInt(p.value);
          }
          if (Number.isInteger(p.value)) {
            if (p.value != p.original_value) {
              change_found = true;
            }
          }
        });
      });
      return change_found;
    },
    copyFromRoleOptions() {
      return this.user_types_list.filter((ut) => ut.id != this.selected_role_data.id);
    },
    visibleRoleModules() {
      return (this.user_role_permissions_modules || []).filter((mod) => this.moduleMatchesFilters(mod));
    },
  },
  methods: {
    hasPermissionMatrix,
    async refreshPermissionCatalog() {
      try {
        const catalog = await RolePermissions.catalog();
        if (Array.isArray(catalog) && catalog.length) {
          this.permissions_modules = catalog;
          localStorage.user_roles = JSON.stringify(catalog);
        }
      } catch (error) {
        // keep cached catalog
      }
    },
    moduleHasChanges(mod) {
      return (mod.permissions || []).some((p) => Number.isInteger(p.value) && p.value != p.original_value);
    },
    permissionMatchesSearch(permission, query) {
      if (!query) return true;
      return `${permission.short_description || ""} ${permission.name || ""} ${permission.description || ""}`.toLowerCase().includes(query);
    },
    moduleMatchesFilters(mod) {
      const query = (this.permissionSearch || "").toLowerCase().trim();
      if (this.showChangedOnly && !this.moduleHasChanges(mod)) return false;
      if (!query) return true;
      if ((mod.module_title || "").toLowerCase().includes(query) || (mod.module_name || "").toLowerCase().includes(query)) {
        return true;
      }
      return (mod.permissions || []).some((p) => this.permissionMatchesSearch(p, query));
    },
    visibleModulePermissions(mod) {
      const query = (this.permissionSearch || "").toLowerCase().trim();
      return (mod.permissions || []).filter((p) => {
        if (this.showChangedOnly && !(Number.isInteger(p.value) && p.value != p.original_value)) return false;
        return this.permissionMatchesSearch(p, query);
      });
    },
    async fetch_users() {
      const params = {
        show_inactive: this.users_show_inactive ? "1" : "0",
      };
      if (this.users_filter_type_id !== "") {
        params.type_id = this.users_filter_type_id;
      }
      await Api(true)
        .get("/user/get/users", { params })
        .then((res) => {
          this.users_list = (res.data || []).map((u) => {
            u.edit_mode = false;
            return u;
          });
          this.users_list = this.users_list.map((u) => {
            u.role = { id: 0 };
            this.user_types_list.map((ut) => {
              if (u.type_id == ut.id) {
                u.role = ut;
              }
            });
            return u;
          });
        });
    },
    get_user_types() {
      Api(true)
        .post("/get/user/types")
        .then((res) => {
          this.user_types_list = res.data.map((ut) => {
            ut.edit_mode = false;
            ut.new_name = ut.name;
            return ut;
          });
        });
    },
    start_create_new_role(copyFrom = null) {
      this.show_create_new_role = copyFrom ? true : !this.show_create_new_role;
      if (this.show_create_new_role) {
        this.form_create_role_data = {
          name: copyFrom ? "Kopjo rolin" : "Krijo nje rol te ri",
          submit: {
            label: copyFrom ? "Kopjo" : "Krijo",
            action: "create_role",
          },
          fields: [
            [
              {
                value: copyFrom ? copyFrom.name + " (kopje)" : "",
                name: "name",
                label: "Emri i rolit",
                type: "text-field",
                style: "flex-grow: 1",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
              },
            ],
            [
              {
                value: copyFrom ? copyFrom.id : "",
                name: "copy_from_type_id",
                label: "Kopjo te drejtat nga",
                type: "select-field",
                style: "flex-grow: 1",
                required: false,
                options: [{ id: "", label: "Nga e para (te gjitha fikur)" }].concat(
                  this.user_types_list.map((ut) => ({
                    id: ut.id,
                    label: ut.name,
                  }))
                ),
              },
            ],
          ],
        };
      }
    },
    start_copy_role(user_type) {
      this.start_create_new_role(user_type);
    },
    close_create_new_role() {
      this.show_create_new_role = !this.show_create_new_role;
      this.new_role = {};
    },
    create_role(role) {
      const payload = {
        name: role.name,
        copy_from_type_id: role.copy_from_type_id || 0,
      };
      Api(true)
        .post("/create/role", payload)
        .then((r) => {
          if (r.data.id) {
            r.data.edit_mode = false;
            r.data.new_name = r.data.name;
            this.user_types_list.push(r.data);
            this.close_create_new_role();
            this.$toast.success("Roli " + r.data.name + " u krijua me sukses.");
            this.change_selected_role(r.data);
          }
        })
        .catch((error) => {
          this.$toast.error(error?.response?.data?.message || "Roli nuk u krijua.");
        });
    },
    change_selected_role(user_type) {
      this.selected_role_data = { ...user_type };
      this.rolePanelTab = "permissions";
      this.permissionSearch = "";
      this.showChangedOnly = false;
      this.copyFromTypeId = "";
      this.roleHistoryReloadKey += 1;
      RolePermissions.getRolePermissions(this.selected_role_data.id).then((data) => {
        if (data.length > 0) {
          this.permissions_merge(data, 1);
        } else {
          var a = [];
          this.permissions_modules.map((m) => {
            var b = {};
            b.id = 0;
            b.type_id = this.selected_role_data.id;
            b.name = m.module_name;
            b.permissions_values = "";

            m.permissions.map(() => {
              b.permissions_values += "0";
            });
            a.push(b);
          });
          this.permissions_merge(a, 1);
        }
        this.user_role_permissions_modules = injectStandaloneAttributeModule(this.user_role_permissions_modules);
      });
      this.show_permissions_section = true;
    },
    applyCopyFromRole() {
      const sourceId = Number(this.copyFromTypeId);
      if (!sourceId || !this.selected_role_data.id) return;
      const currentIds = {};
      const currentOriginals = {};
      (this.user_role_permissions_modules || []).forEach((mod) => {
        currentIds[mod.module_name] = mod.id;
        currentOriginals[mod.module_name] = {};
        (mod.permissions || []).forEach((p) => {
          currentOriginals[mod.module_name][p.name] = p.original_value;
        });
      });
      RolePermissions.getRolePermissions(sourceId).then((data) => {
        this.permissions_merge(data, 1);
        this.user_role_permissions_modules = injectStandaloneAttributeModule(this.user_role_permissions_modules).map((mod) => {
          if (!mod.virtual) {
            mod.id = currentIds[mod.module_name] || 0;
          }
          (mod.permissions || []).forEach((p) => {
            const originals = currentOriginals[mod.module_name] || currentOriginals.product || {};
            if (Object.prototype.hasOwnProperty.call(originals, p.name)) {
              p.original_value = originals[p.name];
            }
          });
          return mod;
        });
        this.$toast.success("Te drejtat u kopjuan. Ruaji per t'i aplikuar.");
      });
    },

    close_add_new_permission() {
      this.show_create_permission = false;
    },
    save_role_permissions() {
      this.save_permissions_loading = true;
      var permissions_values = [];
      this.user_role_permissions_modules.map((p) => {
        if (p.virtual) return;
        var permissions_values_data = {
          id: p.id,
          name: p.module_name,
          permissions_values: "",
        };
        p.permissions.map((pp) => {
          permissions_values_data.permissions_values += pp.value ? 1 : 0;
        });
        permissions_values.push(permissions_values_data);
      });
      Api(true)
        .post("/save/role/permission", {
          type_id: this.selected_role_data.id,
          permissions_data: permissions_values,
        })
        .then(() => {
          this.save_permissions_loading = false;
          // Set original_value = value
          this.user_role_permissions_modules = [
            ...this.user_role_permissions_modules.map((m) => {
              if (m.virtual) return m;
              m.permissions.map((p) => {
                p.original_value = p.value;
                m.id = p.id;
              });
              return m;
            }),
          ];

          this.$toast.success("Te dhenat u ruajten me sukses.");
          this.roleHistoryReloadKey += 1;

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          this.save_permissions_loading = false;
          this.$toast.error(error?.response?.data?.message || "Te drejtat nuk u ruajten.");
        });
    },
    save_user_type(role) {
      Api(true)
        .post("/save/user/type", { user_type: role })
        .then((res) => {
          if (res.data == 1) {
            //
            this.user_types_list.map((ut) => {
              if (ut.id == role.id) {
                ut.name = role.new_name;
                ut.edit_mode = false;
                ut.new_name = ut.name;
              }
              return ut;
            });
            // Selected_role_data
            if (this.selected_role_data.id == role.id) {
              this.selected_role_data.name = role.new_name;
            }
            // Toaster
            this.$toast.success("Te dhenat u ruajten me sukses.");
          }
        });
    },
    start_show_edit_role(role) {
      role.edit_mode = !role.edit_mode;
      if (!role.edit_mode) {
        role.new_name = role.name;
      }
    },
    change_roles_users(v) {
      this.selected_role_data = {};
      this.role_user_tab = v;
    },
    groupPermissions(k) {
      const visible = visiblePermissionNames(k.module_name);
      if (!visible) return k.permissions;
      return k.permissions.filter((permission) => visible.has(permission.name));
    },
    check_all_group(k) {
      const permissions = this.groupPermissions(k);
      let have_empty = [];
      permissions.map((i) => {
        if (!i.value) {
          have_empty.push(i);
        }
      });

      if (have_empty.length == 0) {
        permissions.map((a) => {
          a.value = 0;
          return a;
        });
      } else {
        permissions.map((a) => {
          if (a) a.value = 1;
          return a;
        });
      }
    },
    are_all_checked(k) {
      const permissions = this.groupPermissions(k);
      let have_empty = [];
      permissions.map((i) => {
        if (!i.value) {
          have_empty.push(i);
        }
      });
      return have_empty.length == 0 ? true : false;
    },
    start_edit_user(u) {
      u.edit_mode = !u.edit_mode;

      if (u.edit_mode) console.log("open");
      else {
        if (u.type_id != -1) {
          u.type_id = u.role.id;
        } else {
          u.type_id = -1;
        }
      }
    },
    assign_role(user) {
      Api(true)
        .post("/user/assign/user/role", user)
        .then((res) => {
          if (res.data > 0) {
            this.users_list = [
              ...this.users_list.map((u) => {
                if (u.guid == user.guid) {
                  this.user_types_list.map((ut) => {
                    if (u.type_id == ut.id) u.role = ut;
                  });
                }
                u.edit_mode = false;
                return u;
              }),
            ];
            this.$toast.success("Roli " + user.role.name + " iu percaktua " + user.name + ".");
          }
        });
    },
    get_url() {
      var url = this.$route.path.split("/");
      var route = "";
      if (url[1] == "") {
        route = "/";
      } else {
        route = url[1];
      }
      return route;
    },
    close_create_new_user() {
      this.show_create_new_user = false;
      this.new_user = {};
    },
    start_create_new_user() {
      this.show_create_new_user = !this.show_create_new_user;
      if (this.show_create_new_user) {
        this.form_create_user_data = {
          name: "Krijo Perdorues",
          submit: {
            label: "Krijo",
            action: "create_user",
          },
          fields: [
            [
              {
                value: "",
                name: "name",
                label: "Emri",
                type: "text-field",
                style: "flex-grow: 0.3",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
              },
              {
                value: "",
                name: "lastname",
                label: "Mbiemri",
                type: "text-field",
                style: "flex-grow: 0.3",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
              },
              {
                value: "",
                name: "email",
                label: "Email",
                type: "text-field",
                style: "flex-grow: 0.3",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
              },
            ],
            [
              {
                value: "",
                name: "contact_nr",
                label: "Numer kontakti",
                type: "number-field",
                style: "flex-grow: 1",
              },
            ],
            [
              {
                value: "",
                name: "type_id",
                label: "Roli i perdoruesit",
                type: "select-field",
                style: "flex-grow: 1",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
                options: this.user_types_list.map((e) => {
                  return {
                    ...e,
                    label: e.name,
                  };
                }),
              },
            ],
            [
              {
                value: "",
                name: "password",
                label: "Password",
                type: "password-field",
                style: "flex-grow: 0.45",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
              },
              {
                value: "",
                name: "password_confirmation",
                label: "Perserit Password",
                type: "password-field",
                style: "flex-grow: 0.45",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
              },
            ],
          ],
        };
      }
    },
    async create_user(data) {
      Api()
        .post("user/create/register", data)
        .then((r) => {
          r.data[0].edit_mode = false;
          this.user_types_list.map((t) => {
            if (t.id == r.data[0].type_id) {
              r.data[0].role = t;
            }
          });

          this.$toast.success("Perdoruesi u krijua me suksess.");
          this.form_create_user_data = false;

          var a = [...this.users_list];
          this.users_list = [];
          a.push(r.data[0]);
          this.users_list = [...a];
        });
    },
    async open_edit_user_form(user) {
      this.selected_user = { ...user };
      this.userFormTab = "form";
      this.userHistoryReloadKey += 1;
      this.form_edit = { loading: true };
      this.form_edit = await editUser(user);
    },
    closeUserForm() {
      this.form_edit = null;
      this.userFormTab = "form";
    },
    submitUser(u) {
      // Save user data (edit)
      Api(true)
        .post("/user/save/data", { user: u, selected_user: this.selected_user })
        .then((res) => {
          // Close form ?
          this.form_edit = null;
          this.userFormTab = "form";
          if (res.data.message == "User updated succesfuly") {
            this.$toast.success("Te dhenat u ruajten me sukses.");
            this.userHistoryReloadKey += 1;

            this.users_list = [
              ...this.users_list.map((user) => {
                if (user.id == res.data.updated_user[0].id) {
                  user = { ...{} };
                  user = { ...res.data.updated_user[0] };
                  this.user_types_list.map((ut) => {
                    if (user.type_id == ut.id) {
                      user.role = ut;
                    }
                  });
                }
                return user;
              }),
            ];
          }
        })
        .catch((error) => {
          this.$toast.error(error?.response?.data?.message || "Perdoruesi nuk u ruajt.");
        });
    },
    toggle_collapse_role(role) {
      // console.log('role', role)
      this.user_role_permissions_modules.map((m) => {
        if (m.module_name == role.module_name) {
          m.is_collapsed = !m.is_collapsed;
        }
        return m;
      });
    },
  },
  // directives: {
  //   tippy: directive,
  // },
};
</script>

<style>
.tabe-content {
  border: solid #dedede;
  border-width: 0px 1px 1px;
}
.role-editor-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.role-editor-toolbar .input {
  max-width: 16rem;
}
</style>
